.ugc-pdp-question-and-answer-desktop-box {
  .alert-wrap {
    left: auto;
    transform: none !important;
  }
}

.alert-wrap {
  position: fixed;
  top: 16px;
  z-index: 9999999999;
  @at-root [dir='ltr'] & {
    right: 16px;
  }
  @at-root [dir='rtl'] & {
    left: 16px;
  }
  .alert-content {
    position: relative;
    margin-bottom: 16px;
    width: 343px;
    height: 80px;
    padding: 16px;
    border-radius: 8px;
    &.alert-content-success {
      background: #458500;
      .alert-message {
        color: #fff;
      }
    }

    &.alert-content-warn {
      background: #ffea00;
      .alert-message {
        color: #333;
      }
    }

    &.alert-content-error {
      background: #d32f2f;
      .alert-message {
        color: #fff;
      }
    }
  }
}

.alert-right-enter {
  animation: moveRight 0.3s;
}

@keyframes moveRight {
  0% {
    right: -200%;
  }
  100% {
    right: 0;
  }
}

.alert-left-enter {
  animation: moveLeft 0.3s;
}

@keyframes moveLeft {
  0% {
    left: -200%;
  }
  100% {
    left: 0;
  }
}
